import * as React from 'react';
import {Svg, Mask, Path, G} from 'react-native-svg';

const USAFlag = props => {
  return (
    <Svg
      width={24}
      height={16}
      viewBox="0 0 24 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <Mask
        id="a"
        style={{
          maskType: 'alpha',
        }}
        maskUnits="userSpaceOnUse"
        x={0}
        y={0}
        width={24}
        height={16}>
        <Path fill="#C4C4C4" d="M0 0H24V16H0z" />
      </Mask>
      <G mask="url(#a)">
        <Path d="M24 0H0v16h24V0z" fill="#fff" />
        <Path
          d="M24 2H0v2h24V2zM24 6H0v2h24V6zM24 10H0v2h24v-2zM24 14H0v2h24v-2z"
          fill="#ED0000"
        />
        <Path d="M12 0H0v8.615h12V0z" fill="#4962FF" />
        <Path
          d="M4.68 3.53l-.194.594h-.625l.506.367-.194.595.506-.368.506.368-.193-.595.505-.367h-.625l-.193-.595zM4.872 6.27l-.193-.595-.193.595h-.625l.506.367-.194.595.506-.368.506.368-.193-.595.505-.367h-.625zM2.23 6.27l-.193-.595-.193.595h-.625l.506.367-.194.595.506-.368.506.368-.194-.595.506-.367H2.23zM2.037 3.53l-.193.594h-.625l.506.367-.194.595.506-.368.506.368-.194-.595.506-.367H2.23l-.193-.595zM4.68 1.384l-.194.594h-.625l.506.368-.194.594.506-.367.506.367-.193-.594.505-.368h-.625l-.193-.594zM2.037 1.384l-.193.594h-.625l.506.368-.194.594.506-.367.506.367-.194-.594.506-.368H2.23l-.193-.594zM7.321 3.53l-.193.594h-.625l.505.367-.193.595.506-.368.506.368-.194-.595.506-.367h-.625l-.193-.595zM7.514 6.27l-.193-.595-.193.595h-.625l.505.367-.193.595.506-.368.506.368-.194-.595.506-.367h-.625zM10.156 6.27l-.193-.595-.193.595h-.625l.506.367-.194.595.506-.368.506.368-.194-.595.506-.367h-.625zM9.963 3.53l-.193.594h-.625l.506.367-.194.595.506-.368.506.368-.194-.595.506-.367h-.625l-.193-.595zM7.321 1.384l-.193.594h-.625l.505.368-.193.594.506-.367.506.367-.194-.594.506-.368h-.625l-.193-.594zM9.963 1.384l-.193.594h-.625l.506.368-.194.594.506-.367.506.367-.194-.594.506-.368h-.625l-.193-.594z"
          fill="#fff"
        />
      </G>
    </Svg>
  );
};

export default USAFlag;
